import React from 'react';
import PropTypes from 'prop-types';
import Image from '@gc-npm/components.c-image';
import { COLORS } from '@gc-npm/utils.enums.colors';
import TextInfo, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_SIZE,
  TEXT_HEADING_LEVEL,
  TEXT_FONT_WEIGHT,
} from '@gc-npm/components.text';
import Price, {
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
} from '@gc-npm/components.price';
import Label, { LABEL_SHAPES, LABEL_TYPES } from '@gc-npm/components.cms-block.cms-label';

export const DeviceCard = ({
  device,
  isSelected,
  hasStamps,
  isR2rAditional,
}) => {
  const {
    img,
    name,
    price,
    stamp,
  } = device;

  return (
    <>
      <div
        className={`DeviceCard ${isSelected ? 'selectedDevice' : ''}`}
      >
        {stamp && (
          <Label text={stamp} shape={LABEL_SHAPES.TEARS} type={LABEL_TYPES.ACTIVE}/>
        )}
        <div className={`DeviceCard-content ${hasStamps ? 'hasStamps' : ''}`}>
          <div className="DeviceCard-content_image">
            <Image fill src={img} alt={name} />
          </div>
          <div className="DeviceCard-content_info">
            <div className="DeviceCard-content_info--title">
              <TextInfo
                text={name}
                kind={TEXT_KIND.HEADING}
                level={TEXT_HEADING_LEVEL.H3}
                color={TEXT_COLOR.MOVISTAR_BLACK}
                size={TEXT_SIZE.CAPTION}
                fontType={TEXT_FONT_WEIGHT.BOLD}
              />
            </div>

            {price && (
              <div className="DeviceCard-content_info--prices">
                {!isR2rAditional && (
                  <TextInfo
                    text="Desde"
                    kind={TEXT_KIND.PARAGRAPH}
                    color={TEXT_COLOR.MOVISTAR_BLACK}
                    size={TEXT_SIZE.SUBTITLE2}
                    fontType={TEXT_FONT_WEIGHT.BOLD}
                  />
                )}
                <Price
                  cyData={`module-${name}-price`}
                  size={PRICE_SIZE.XXXS}
                  price={price}
                  color={TEXT_COLOR.MOVISTAR_BLACK}
                  currency="€"
                  quote="mes"
                  fontType={PRICE_FONT_WEIGHT.BOLD}
                  fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .DeviceCard {
            position: relative;
            width: 256px;
            min-width: 256px;
            height: 133px;
            border: 1px solid ${COLORS.grey200};
            border-radius: 1rem;
            background-color: white;
            
            &.selectedDevice {
              border: 1.6px solid ${COLORS.movistarBlue};
              background-color: #f5fcff;
            }
            :global(.DeviceCard-wrapper) {
              width: 100%;
            }
            &-content {
              display: flex;
              gap: 1rem;
              padding: 1rem;
              &.hasStamps {
                margin-top: 1rem;
              }
              &_image {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                max-width: 65px;
                min-width: 65px;
                max-height: 87px;
              }
              :global(.DeviceCard-content_image img) {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
              &_info {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                &--title {
                  height: 44px;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                &--button {
                  width: max-content;
                }
                &--prices {
                  display: flex;
                  gap: 0.5rem;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

DeviceCard.propTypes = {
  device: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
};

DeviceCard.defaultProps = {
  isSelected: false,
};

export default DeviceCard;
